import "vanilla-cookieconsent/dist/cookieconsent.css"
import "@orestbida/iframemanager/dist/iframemanager.css";
import * as CookieConsent from "vanilla-cookieconsent"
import "@orestbida/iframemanager/dist/iframemanager.js";

document.addEventListener("DOMContentLoaded", () => {

  const im = iframemanager();

  im.run({
    currLang: "de",
    services: {
      youtube: {
        embedUrl: "https://www.youtube-nocookie.com/embed/{data-id}?autoplay=1&rel=0&enablejsapi=1",
        thumbnailUrl: "https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg",

        iframe: {
          allow:
            "accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;",
        },

        languages: {
          de: {
            notice:
              'Dieser Inhalt wird von Youtube gehostet. Durch die Anzeige des externen Inhalts akzeptieren Sie die <a rel="noreferrer" href="https://www.youtube.com/t/terms" title="Bedingungen und Konditionen" target="_blank">Bedingungen und Konditionen</a> von youtube.com.',
            loadBtn: "Video laden",
            loadAllBtn: "Nicht nochmal fragen",
          },
        },
      },
    }
  })

  CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: "cloud",
        position: "bottom",
        equalWeightButtons: false,
        flipButtons: false
      },
      preferencesModal: {
        layout: "box",
        equalWeightButtons: true,
        flipButtons: false,
      },
    },
    categories: {
      necessary: {
        readOnly: true,
        enabled: true
      },
      meta: {
        enabled: false,
        readOnly: false,
        autoClear: true,
      },
      linkedin: {
        enabled: false,
        readOnly: false,
        autoClear: true,
      },
      youtube: {
        enabled: false,
        readOnly: false,
        autoClear: true,
      }
    },
    language: {
      default: "de",
      translations: {
        de: {
          consentModal: {
            title: "🍪&nbsp;&nbsp;Wir verwenden Cookies!",
            description: "Diese Website nutzt essenzielle Cookies für den Betrieb. Optional können Sie zustimmen, dass wir zusätzliche Dienste wie Meta Pixel oder LinkedIn Insight einsetzen. <a href='/datenschutz'>Mehr erfahren</a>",
            acceptAllBtn: "Alle akzeptieren",
            acceptNecessaryBtn: "Nur notwendige",
            showPreferencesBtn: "Einstellungen"
          },
          preferencesModal: {
            title: "Datenschutz-Einstellungen",
            acceptAllBtn: "Alle akzeptieren",
            acceptNecessaryBtn: "Nur notwendige",
            savePreferencesBtn: "Einstellungen speichern",
            closeIconLabel: "Einstellungen schließen",
            serviceCounterLabel: "Dienst|Dienste",
            sections: [
              {
                title: "🍪 Wer hat Cookies gesagt?",
                description:
                  'Hier können Sie steuern, welche Dienste wir einsetzen dürfen. Mehr dazu finden Sie in unserer <a href="/datenschutz">Datenschutzerklärung</a>.',
              },
              {
                title:
                  'Technisch notwendige Cookies <span class="pm__badge">Immer aktiv</span>',
                description:
                  "Diese Cookies sind für den sicheren und funktionalen Betrieb der Website erforderlich.",
                linkedCategory: "necessary",
              },
              {
                title: "Meta Pixel (Facebook)",
                description:
                  "Helfen Sie uns, die Wirksamkeit unserer Facebook-Kampagnen zu messen und Werbung gezielt auszuspielen.",
                linkedCategory: "meta",
              },
              {
                title: "LinkedIn Insight",
                description:
                  "Ermöglichen Sie uns, Besuche von LinkedIn auszuwerten und Zielgruppen für Werbung besser zu verstehen.",
                linkedCategory: "linkedin",
              },
            ]
          },
          categories: {
            necessary: {
              title: "Notwendige Cookies",
              description: "Diese Cookies sind für den Betrieb der Website erforderlich und können nicht deaktiviert werden."
            },
            meta: {
              title: "Meta Pixel (Facebook)",
              description: "Helfen Sie uns, die Wirksamkeit unserer Facebook-Kampagnen zu messen und Werbung gezielt auszuspielen."
            },
            linkedin: {
              title: "LinkedIn Insight",
              description: "Ermöglichen Sie uns, Besuche von LinkedIn auszuwerten und Zielgruppen besser zu verstehen."
            },
          }
        }
      }

    }
  })
})
